"use client";

import CollectionCard from "@/components/entities/collection-card";
import { useCollectionPageData } from "../../hooks/useCollectionPageData";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const CollectionsList = () => {
  const { collections } = useCollectionPageData();

  if (!collections || !collections.collections?.length || collections.loading) {
    return null;
  }

  return (
    <Container className={S.collectionsWrapper}>
      {collections.collections.map(collection => (
        <CollectionCard collection={collection} key={collection.id} />
      ))}
    </Container>
  );
};

export default CollectionsList;
